import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";


@Component({
    selector: 'ei-structure-basic-component',
    templateUrl: 'ei-structure-basic.component.html',
    standalone: false
})
export class EiStructureBasicComponent implements OnInit, OnChanges {

    @Input() structureId: number;

    initialized: boolean;
    basicWidget: WidgetData;

    private builtForId: number;

    ngOnInit() {
        this.initComponent();
        this.initialized = true;
    }

    initComponent() {
        if (!this.structureId) {
            return;
        }
        // Skip rebuild on every change-detection pass; only rebuild when the parent id actually changes.
        if (this.basicWidget && this.builtForId === this.structureId) {
            return;
        }
        this.basicWidget = WidgetFactory.createWidgetEntityData(
            'ei.structure.basic.data.widget',
            'Struktur',
            'ei.EiStructure',
            this.structureId
        );
        this.builtForId = this.structureId;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
        this.initComponent();
    }

}
